import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { getlandingPage } from '../../data/templates'
import { getAllModule } from '../../data/modulesData'
import Head from 'next/head'
import Script from 'next/script'
import dynamic from 'next/dynamic'
import { Container } from 'react-bootstrap'

const Components = dynamic(() => import('./Components'), {ssr:true})
const Landing = ({ landing, modules }) => {
  let [language, setLanguage] = useState('en')
  useRouter()
  let TagName = ''

  if (landing !== undefined && landing !== null && landing !== '' && 'renderComponents' in landing) {
    TagName = Object.entries(landing?.renderComponents).map(([key, value]) => {
      return(
        <Components 
        key={key} 
        cName={key} 
        cProps={value} 
        hideHeader={'hideHeader' in landing? landing?.hideHeader : 0}
        modules={modules} template={landing?.template} 
        selectLanguage={(option) => setLanguage(option)} 
        />

      ) 
    })
  }
  return (
    <>
      <Head>
        <meta property="og:title" content={landing?.title} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`https://web.hr/${landing?.slug}`} />
        <meta property="og:image" content="https://web.hr/WebHR_OG.png" />
        <meta property="og:description" content={landing?.metaDescription} />
        <meta name="description" content={landing?.metaDescription} />
        <link rel="canonical" href={`https://web.hr/get/${landing?.slug}`} key="canonical-link" />
        <link rel="manifest" href="/manifest.json"></link>
        {landing?.title && <title>{landing?.title}</title>}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "SoftwareApplication",
              "applicationCategory": "BusinessApplication",
              "name": "WebHR",
              "description": "WebHR is a Social all-in-one HR software that covers entirely from Hire to Retire for the most important asset in your company - your employees. WebHR is an indispensable tool not just for HR but for the entire company. WebHR is based on Software as a Service (SaaS) and Cloud Computing model.",
              "aggregateRating": {
                "@type": "AggregateRating",
                "reviewCount": 1678,
                "ratingValue": 4.8,
                "bestRating": 5
              },
              "review": {
                "@type": "Review",
                "author": {
                  "@type": "Person",
                  "name": "Ali Raheel Khowaja"
                },
                "reviewBody": "Great HR software, very useful!",
                "reviewRating": {
                  "@type": "Rating",
                  "bestRating": 5,
                  "ratingValue": 5,
                  "worstRating": 1
                }
              },
              "operatingSystem": "Cloud, SaaS, Web-based, Desktop Mac, Desktop Windows, Mobile Android, Mobile iPhone, Mobile iPad"
            }),
            }}
          />
      </Head>
      {landing?.tagManagerId && (
        <>
          <Script id="googletagmanagerID" async="" type="text/javascript" src={`https://www.googletagmanager.com/gtag/js?id=${landing?.tagManagerId}`} />
          <Script
            id="googletagmanagerID"
            dangerouslySetInnerHTML={{
              __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${landing?.tagManagerId}', {
              page_path: window.location.pathname,
            });
            `,
            }}
          />
        </>
      )}
      {landing?.TrackingInfo?.DefaultTracking?.length > 0
        ? landing?.TrackingInfo?.DefaultTracking.map((item, index) => {
            if (item?.Type == 'GTM') {
              return (
                <>
                  <Script key={index} id="googletagmanagerID" async="" type="text/javascript" src={`https://www.googletagmanager.com/gtag/js?id=${item?.Value1}`} />
                  <Script
                    key={index}
                    id="googletagmanagerID"
                    dangerouslySetInnerHTML={{
                      __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${item?.Value1}', {
              page_path: window.location.pathname,
            });
          `,
                    }}
                  />
                </>
              )
            }
          })
        : null}
      <Container style={{margin:0, padding:"0px"}} fluid dir={language === 'ar' ? 'rtl' : 'ltr'}> {TagName}</Container>
    </>
  )
}

Landing.getInitialProps = async ({ query }) => {
  const landing = await getlandingPage(query.Landing)
  const modules = await getAllModule()
  return { landing, modules }
}

export default Landing